module.exports = __webpack_public_path__ + "static/img/GANG TF.5998ad5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/GANG TF.png
// module id = yG/Y
// module chunks = 1